import React from "react";
import cx from "classnames";

type Props = {
  label?: string;
  labelStyle?: any;
  isHelp?: boolean;
  helpText?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const DateInputAuth: React.FC<Props> = ({
  label,
  labelStyle,
  helpText,
  isHelp,
  className,
  value,
  onChange,
}): JSX.Element => {
  return (
    <div className={cx("flex flex-col", className)}>
      {label && (
        <span
          className="font-sora text-sm"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#A5A5A5",
          }}
        >
          {label}
        </span>
      )}
      <div className="flex flex-row">
        <input
          className={cx(
            "w-full mr-3 h-14 text-sm",
            isHelp ? "border-bt-red my-1" : "my-2"
          )}
          style={{
            background: "#FFFFFF",
            border: isHelp ? "2px solid #FD5B28" : "0.5px solid #8E8E8E",
            borderRadius: "4px",
          }}
          type="date"
          value={value}
          onChange={onChange}
          autoComplete="off"
        />
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default DateInputAuth;
